// Core HTTP client — builds URLs, handles fetch, parses JSON.

const BASE_URL = process.env.BACKEND_URL || "";
const TOKEN_KEY = "miai_auth_token";

function _getStoredToken() {
  try {
    const raw = localStorage.getItem(TOKEN_KEY);
    return raw ? JSON.parse(raw)?.access_token || null : null;
  } catch {
    return null;
  }
}

const buildUrl = (endpoint, query) => {
  const url = new URL(`${BASE_URL}${endpoint}`, window.location.origin);
  if (query) {
    Object.entries(query).forEach(([k, v]) => {
      if (v !== undefined && v !== null) url.searchParams.set(k, v);
    });
  }
  return url.toString();
};

const request = async (method, endpoint, { body, query } = {}) => {
  const url = buildUrl(endpoint, query);
  const opts = { method, headers: {} };

  const token = _getStoredToken();
  if (token) {
    opts.headers["Authorization"] = `Bearer ${token}`;
  }

  if (body) {
    opts.headers["Content-Type"] = "application/json";
    opts.body = JSON.stringify(body);
  }

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 120_000);
  opts.signal = controller.signal;

  let res;
  try {
    res = await fetch(url, opts);
    clearTimeout(timeoutId);
  } catch (networkErr) {
    clearTimeout(timeoutId);
    if (networkErr.name === "AbortError") {
      throw new Error("Request timed out after 2 minutes. Please try again.");
    }
    throw new Error(`Network error: ${networkErr.message} (${endpoint})`);
  }

  if (res.status === 401) {
    try { localStorage.removeItem(TOKEN_KEY); } catch {}
    window.dispatchEvent(new CustomEvent("miai:auth-expired"));
    throw new Error("Session expired. Please sign in again.");
  }

  if (!res.ok) {
    const detail = await res.text();
    throw new Error(`API ${res.status}: ${detail}`);
  }

  return await res.json();
};

const API = {
  get: (endpoint, opts) => request("GET", endpoint, opts),
  post: (endpoint, opts) => request("POST", endpoint, opts),
  put: (endpoint, opts) => request("PUT", endpoint, opts),
  patch: (endpoint, opts) => request("PATCH", endpoint, opts),
  delete: (endpoint, opts) => request("DELETE", endpoint, opts),
};

export default API;
